import React, { useState } from 'react';

function readHubspotutk() {
    if (typeof document === 'undefined') return '';
    const match = document.cookie.match(/(?:^|;\s*)hubspotutk=([^;]+)/);
    return match ? match[1] : '';
}

const HubSpotForm = ({
    portalId,
    formId,
    fields,
    submitLabel = 'Submit',
    successMessage = "Thanks — we'll be in touch.",
    pageName,
}) => {
    const initial = Object.fromEntries(fields.map((f) => [f.name, '']));
    const [values, setValues] = useState(initial);
    const [status, setStatus] = useState('idle');
    const [errorMsg, setErrorMsg] = useState('');

    const onChange = (name) => (e) => {
        setValues((v) => ({ ...v, [name]: e.target.value }));
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        setStatus('submitting');
        setErrorMsg('');

        const hutk = readHubspotutk();
        const context = {
            pageUri: typeof window !== 'undefined' ? window.location.href : '',
            pageName: pageName || (typeof document !== 'undefined' ? document.title : ''),
        };
        if (hutk) context.hutk = hutk;

        const payload = {
            fields: fields.map((f) => ({
                objectTypeId: '0-1',
                name: f.name,
                value: values[f.name] || '',
            })),
            context,
        };

        try {
            const res = await fetch(
                `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`,
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload),
                }
            );

            if (!res.ok) {
                const body = await res.json().catch(() => ({}));
                const msg =
                    body?.errors?.[0]?.message ||
                    body?.message ||
                    `Submission failed (${res.status})`;
                setErrorMsg(msg);
                setStatus('error');
                return;
            }

            setStatus('success');
        } catch (err) {
            setErrorMsg('Network error — please try again.');
            setStatus('error');
        }
    };

    if (status === 'success') {
        return <div className="qc-form-success">{successMessage}</div>;
    }

    return (
        <form className="qc-form" onSubmit={onSubmit} noValidate>
            {fields.map((f) => {
                const id = `qc-${formId}-${f.name}`;
                const common = {
                    id,
                    name: f.name,
                    value: values[f.name],
                    onChange: onChange(f.name),
                    required: !!f.required,
                    placeholder: f.placeholder || '',
                };
                return (
                    <div className="qc-form-field" key={f.name}>
                        <label htmlFor={id}>
                            {f.label}
                            {f.required ? <span aria-hidden="true"> *</span> : null}
                        </label>
                        {f.type === 'textarea' ? (
                            <textarea rows={f.rows || 4} {...common} />
                        ) : (
                            <input type={f.type || 'text'} {...common} />
                        )}
                    </div>
                );
            })}

            {status === 'error' && (
                <div className="qc-form-error" role="alert">{errorMsg}</div>
            )}

            <button
                type="submit"
                className="qc-form-submit"
                disabled={status === 'submitting'}
            >
                {status === 'submitting' ? 'Sending…' : submitLabel}
            </button>
        </form>
    );
};

export default HubSpotForm;
